<template>
  <div class="container padding-max-vertical">
    <card title="playground">
      <div>
        <form-button @click="testServer">בדיקה</form-button>
      </div>
    </card>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import _ from "lodash";

export default {
  layout: "default",
  middleware: {},
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady } = asyncOperations(props);

    return { asyncOps, asyncOpsReady };
  },
  data: function () {
    return {
      formData: {},
      formConfigBase: {
        context: "create",
        fields: {
          name: {
            name: "name",
            type: "text",
            label: "שם מלא",
            autoTranslate: false,
            validation: {
              required: {},
            },
          },
          email: {
            name: "email",
            type: "email",
            label: "כתובת המייל שלי",
            autoTranslate: false,
            validation: {
              required: {},
              email: {},
            },
          },
        },
        buttons: {
          submit: {
            type: "submit",
            text: "OK!",
          },
        },
      },
      formConfigOverride: {},
    };
  },
  serverPrefetch() {
    return this.getSSRPrefetchPromise();
  },
  computed: {
    mergedFormConfig() {
      let res = _.cloneDeep(this.formConfigBase);
      if (this.formConfigOverride) {
        res = _.merge(res, this.formConfigOverride);
      }

      return res;
    },
  },
  methods: {
    async testServer() {
     // let url = `playground/use-case`;
       let url = `generic/test2`;

      let callResult = await this.asyncOps.asyncCall(url, {method:"get"});
      console.log("----------");
      console.log("call info", url);
      console.log("=====");
      console.log("call status");
      if (callResult.hasError) {
        console.log("%c failed", "color: red;");
      } else {
        console.log("%c success", "color: green;");
      }
      console.log(callResult?.data);
    },
  },
};
</script>

<style scoped lang="scss"></style>
